// eslint-disable-next-line no-extend-native
Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

const getEmptyMenueWahlTable = (value, datum) => {
    const retVal = [];
    const d = datum ? new Date(datum) : new Date();
    d.setHours(0,0,0,0);
    const offset = (d.getDay() + 6) % 7;
    // console.log(`Heute: ${d.toDateString()}, Offset: ${offset}`)
    d.setDate( d.getDate() - offset );
    // console.log(`Montag: ${d.toDateString()}`)
    for (var i = 0; i < 14; i++) {
        var dat = d.addDays(i);
        retVal.push({ DATUM: dat.toISOString(), WAHL: value });
    }

    return retVal;
}

const refillMenueWahlTable = (data, firstDate) => {
    // const firstDate = data.FirstDate;
    const newMenueWahlTable = { Fruehstueck: getEmptyMenueWahlTable(0, firstDate), Abendessen: getEmptyMenueWahlTable(0, firstDate), ToGo: getEmptyMenueWahlTable(0, firstDate), MenueWahl: getEmptyMenueWahlTable(0, firstDate), Sonstiges: getEmptyMenueWahlTable('', firstDate)}
    // console.log('refillMenueWahlTable called', data, newMenueWahlTable)
    if (data) {
        const firstMonday = new Date(data.FirstDate);
        const index = ((new Date(newMenueWahlTable.MenueWahl[0].DATUM)) - firstMonday) / (24 * 60 * 60 * 1000);
        if (index >= 0) {
            let j = 0;
            for (let i = index; i < data.MenueWahl.length; i++) {
                // console.log('refillMenueWahlTable index', i, j, newMenueWahlTable.MenueWahl[j].MENUE)
                newMenueWahlTable.Fruehstueck[j].WAHL = data.Fruehstueck[i];
                newMenueWahlTable.Abendessen[j].WAHL = data.Abendessen[i];
                newMenueWahlTable.ToGo[j].WAHL = data.ToGo[i];
                newMenueWahlTable.MenueWahl[j].WAHL = data.MenueWahl[i];
                newMenueWahlTable.Sonstiges[j++].WAHL = data.Sonstiges ? data.Sonstiges[i] : '';
            }
            // newMenueWahlTable.MenueWahl = newMenueWahlTable.MenueWahl.map(({ WAHL: MENUE, ...rest}) => ({ MENUE, ...rest}));
        }
        // console.log('refillMenueWahlTable called, result is', firstMonday, (new Date(newMenueWahlTable.MenueWahl[0].DATUM)), index, newMenueWahlTable);
    }
    return newMenueWahlTable;
}

export {
     getEmptyMenueWahlTable,
     refillMenueWahlTable,
};